import { UserState } from '@wearejh/m2-pwa-user';

/**
 * Is the user logged in and subscribed to the marketing emails?
 *
 * @param state
 * @returns {boolean}
 */
export function isSubscribedUser(state?: Record<string, unknown>) {
    const user = state?.['user'] as UserState | undefined;

    const isLoggedIn = user?.session === 'SignedIn';
    const isSubscribed = user?.data?.extension_attributes?.is_subscribed === true;

    return isLoggedIn && isSubscribed;
}
